import { render, staticRenderFns } from "./SupplierAdd.vue?vue&type=template&id=283bb20c&scoped=true"
import script from "./SupplierAdd.vue?vue&type=script&lang=js"
export * from "./SupplierAdd.vue?vue&type=script&lang=js"
import style0 from "./SupplierAdd.vue?vue&type=style&index=0&id=283bb20c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283bb20c",
  null
  
)

export default component.exports